
/**
 * 图片压缩，根据width，向上取合适的压缩比例，压缩格式优先采用：webp > jpg > png。
 * 高度根据图片比例自适应
 * 根据devicePixelRatio，返回合适的分辨率，目前只兼容到devicePixelRatio=3的情况，再高的像素比目前认为没必要
 *  https://wiki.quickcan.com/pages/viewpage.action?pageId=139362566
 *  测试示例
 *  https://f12stag.kkmh.com/game/200428/KShmqb0qh.jpg-t.w750.webp.h
 *  https://f12stag.kkmh.com/game/200428/u9KR17xeF.png-t.w750.webp.h
 * @param {String} url 需要增加压缩后缀的url
 * @param {Number} width 压缩宽度，以苹果750出图的分辨率为基准传参，例如750的出图图片宽度是100，传100
 * @param {Boolean} isAlpha 是否需要支持透明度压缩，true：ios会采用png，android采用webp，false：iose采用jpg，android采用webp
 * @param {Boolean} isRatio 是否根据window.devicePixelRatio调整尺寸，例如window.devicePixelRatio=3的设备，会把宽度增加1/3。默认是true
 * @param {String} quality 表示图片的质量：h表示高质量，m表示中质量，l表示low低质量，u表示更高清
 */

let dpi = window.devicePixelRatio >= 3? 3 : 2;
const qualitys = {
  'webp': ['h', 'l', 'u'],
  'jpg': ['h', 'l'],
  'png': ['h']
};
const compress = (url, width = 50, isAlpha, isRatio = true, quality = 'h') => {
  if (!url) {
    console.warn('@kk/utils/compress必填参数url缺失');
    return '';
  }
  // 正则判断url是否已携带压缩后缀
  // 移除已有压缩后缀并按照传入参数追加压缩后缀
  const reg = /-(c\.w\.i\d+|c\.w\d+|cw\.w\d+|fe\.w\d+|h\.w\d+|h\.w\.i\d+|icon|lw\d+$|lw\d+\..+|o\d+$|o\d+\..+|o\.i\d+|w\d+$|w\d+\..+|yyb|t\.w\d+)/;
  const matchResult = url && url.match(reg);
  if (matchResult) {
    console.warn('该url包含cdn压缩后缀，如无特殊需求，请告知服务端移除压缩后缀，统一由客户端处理');
    console.warn('当前已通过正则移除服务端下发压缩后缀，并按需增加前端压缩后缀');
    url = url.slice(0, matchResult.index);
  }

  // Apple UA列表：https://wiki.quickcan.com/pages/viewpage.action?pageId=351011925
  // IOS 14支持webp： https://developer.apple.com/documentation/safari-release-notes/safari-14-release-notes
  const ua = navigator.userAgent.toLowerCase();
  const isApple = /iphone|ipad|ios|mac/.test(ua);
  const iosMajorVersion = (ua.match(/(cpu\s+iphone\s+os|cpu\s+os)\s+(\d+)(_\d+){0,2}/) || ['', '', '0', '_0', '_0'])[2];
  const appleWebpSupported = /chrome/.test(ua) || iosMajorVersion >= 14;

  let format = 'webp';
  if (isApple && !appleWebpSupported) {
    if (isAlpha) {
      format = 'png';
    } else {
      format = 'jpg';
    }
  }

  isRatio && (width = width * dpi / 2);

  const widthArr = [50, 70, 90, 120, 180, 207, 320, 360, 414, 540, 563, 640, 720, 750, 828, 960, 1080, 1125, 1280, 1440, 1600, 2160];
  // 向上取最接近的压缩宽度
  for (let i = 0, ii = widthArr.length; i < ii; i++) {
    if (width <= widthArr[i] || i === ii - 1) {
      width = widthArr[i];
      break;
    }
  }

  quality = qualitys[format].indexOf(quality) > - 1? quality : 'h';

  return `${url}-t.w${width}.${format}.${quality}`;
}

export default compress;


// WEBPACK FOOTER //
// ./node_modules/@kk/utils/src/compress.js